import { graphql } from 'app/generated/gql'

export const TAG_COLORS_QUERY = graphql(`
  query AddTagShadcnTagColors($search: String) {
    tagColors(search: $search) {
      hits {
        name
        color
      }
    }
  }
`)
